import { render, staticRenderFns } from "./ChangeVehicle.vue?vue&type=template&id=220e1bbc&scoped=true"
import script from "./ChangeVehicle.vue?vue&type=script&lang=js"
export * from "./ChangeVehicle.vue?vue&type=script&lang=js"
import style0 from "./ChangeVehicle.vue?vue&type=style&index=0&id=220e1bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220e1bbc",
  null
  
)

export default component.exports